import React from 'react'
import Layout from '../../component/Layout';
import { t } from 'i18next';
import CalculateIncidentLevel from '../../component/CalculateIncidentLevel';

const IncidentLevelContainer = () => {
	return (
		<Layout title={t('incident_level')} description={t("features_desc")}>
			<CalculateIncidentLevel />
		</Layout>
	)
}

export default IncidentLevelContainer
